<ps-ui-range-header
  [disabled]="disabled"
  [percent]="percent"
  [value]="valueLabel"
></ps-ui-range-header>
<input
  type="range"
  class="form-range range-slider"
  [min]="min"
  [max]="max"
  [step]="step"
  [ngModel]="value"
  [disabled]="disabled"
  [style]="budgetProgressRangeStyle"
  (ngModelChange)="updateValue($event)"
/>
<ps-ui-range-footer [min]="minLabel" [max]="maxLabel"> </ps-ui-range-footer>
